import store from "../../store";
const router = [
  {
    path: "/beranda/:instansi_id",
    name: "beranda",
    meta: { module: "Beranda", auth: true },
    component: () => import("./pages/HomeUser.vue"),
    beforeEnter: (to, from, next) => {
      let ins = store.getters["instansi/instansi_aktif"];
      if (!ins) {
        next({
          name: "instansi.pilih"
        });
      } else {
        next();
      }
    }
  },
  {
    path: "/beranda/:instansi_id/pppk",
    name: "beranda.pppk",
    meta: { module: "Beranda", auth: true },
    component: () => import("./pages/HomeSeriPPPK.vue"),
    beforeEnter: (to, from, next) => {
      let ins = store.getters["instansi/instansi_aktif"];
      if (!ins) {
        next({
          name: "instansi.pilih"
        });
      } else {
        next();
      }
    }
  },
  {
    path: "/kelola/instansi/:instansi_id/beranda",
    name: "beranda.admin",
    meta: { module: "Beranda", auth: true },
    component: () => import("./pages/HomeAdmin.vue"),
    beforeEnter: (to, from, next) => {
      let ins = store.getters["instansi/instansi_aktif"];
      if (!ins) {
        next({
          name: "instansi.pilih"
        });
      } else {
        next();
      }
    }
  },
  {
    path: "/instansi/:instansi_id/faq",
    name: "faq",
    meta: {
      module: "Faq",
      auth: true
    },
    component: () => import("./pages/FAQ.vue")
  },
  {
    path: "/to-mobile-app",
    name: "mobile.app",
    module: "MobileApp",
    meta: {
      auth: false,
      module: "Menuju Aplikasi Ayo Guru Belajar"
    },
    component: () => import("./pages/ToMobile.vue")
  }
];

export default router;
